// extracted by mini-css-extract-plugin
module.exports = {"inputShift":"_3hQsE","focused":"_3SYQ6","active":"ISldo","error":"_2iFvv","success":"_3nj-R","prefixImg":"_1UmH1","phoneNumberPrefix":"_37TAw"};